"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CONTENT = exports.CLOSABLE_PAGE = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    CLOSABLE_PAGE = function CLOSABLE_PAGE(a) {
  var b = a.backgroundImage;
  return (0, _cxs["default"])({
    background: _vars.COLOURS.mono.white,
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    left: "0",
    position: "fixed",
    top: "0",
    width: "100vw",
    backgroundImage: b ? "url(".concat(b, ")") : void 0,
    backgroundSize: "cover",
    backgroundPosition: "center",
    zIndex: 10,
    overflowY: "auto"
  });
};

exports.CLOSABLE_PAGE = CLOSABLE_PAGE;
var CONTENT = (0, _cxs["default"])({
  paddingTop: "125px"
});
exports.CONTENT = CONTENT;